import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Paper, BottomNavigation, BottomNavigationAction, Menu, MenuItem, Typography, Badge,
} from '@mui/material';
import { ArrowBack, BikeScooter, Home } from '@mui/icons-material';
import PersonIcon from '@mui/icons-material/Person';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { sessionActions } from '../../store';
import { useTranslation } from './LocalizationProvider';
import { useSharing, useSuperManager } from '../util/permissions';
import { nativePostMessage } from './NativeInterface';

const BottomMenu = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const t = useTranslation();

  const superManager = useSuperManager();
  const sharing = useSharing();
  const user = useSelector((state) => state.session.user);
  const socket = useSelector((state) => state.session.socket);

  const [anchorEl, setAnchorEl] = useState(null);

  const currentSelection = () => {
    if (location.pathname === `/user/${user.id}`) {
      return 'account';
    }
    if (location.pathname.startsWith('/rents/rides')) {
      return 'rents';
    }
    if (location.pathname.startsWith('/user')) {
      return 'users';
    }
    if (location.pathname === '/') {
      return 'home';
    }
    return null;
  };

  const handleAccount = () => {
    setAnchorEl(null);
    navigate(`/user/${user.id}`);
  };

  const handleLogout = async () => {
    setAnchorEl(null);

    const notificationToken = window.localStorage.getItem('notificationToken');
    if (notificationToken) {
      window.localStorage.removeItem('notificationToken');
      const tokens = user.attributes.notificationTokens?.split(',') || [];
      if (tokens.includes(notificationToken)) {
        const updatedUser = {
          ...user,
          attributes: {
            ...user.attributes,
            notificationTokens: tokens.length > 1 ? tokens.filter((it) => it !== notificationToken).join(',') : undefined,
          },
        };
        await fetch(`/api/users/${user.id}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updatedUser),
        });
      }
    }

    await fetch('/api/session', { method: 'DELETE' });
    nativePostMessage('logout');
    navigate('/login');
    dispatch(sessionActions.updateUser(null));
  };

  const handleSelection = (event, value) => {
    switch (value) {
      case 'home':
        navigate('/');
        break;
      case 'back':
        navigate(-1);
        break;
      case 'account':
        setAnchorEl(event.currentTarget);
        break;
      case 'rents':
        navigate('/rents/rides');
        break;
      case 'users':
        navigate('/users');
        break;
      case 'logout':
        handleLogout();
        break;
      default:
        break;
    }
  };

  return (
    <Paper square elevation={3}>
      <BottomNavigation value={currentSelection()} onChange={handleSelection} showLabels>
        <BottomNavigationAction icon={<ArrowBack />} value="back" />
        <BottomNavigationAction
          label="Home"
          icon={(
            <Badge color="error" variant="dot" overlap="circular" invisible={socket !== false}>
              <Home />
            </Badge>
          )}
          value="home"
        />
        {sharing && <BottomNavigationAction label={t('rides')} icon={<BikeScooter />} value="rents" />}
        {superManager && <BottomNavigationAction label={t('settingsUsers')} icon={<PersonIcon />} value="users" />}
        <BottomNavigationAction label={t('loginLogout')} icon={<ExitToAppIcon />} value="logout" />
      </BottomNavigation>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem onClick={handleAccount}>
          <Typography color="textPrimary">{t('settingsUser')}</Typography>
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          <Typography color="error">{t('loginLogout')}</Typography>
        </MenuItem>
      </Menu>
    </Paper>
  );
};

export default BottomMenu;
